import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {Row, Col, Radio, Card, Divider, Button } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'

class RequestsPosted extends Component {

  render() {
    return (
        <div>
                <div style={{paddingTop: '30px'}}>
                  <Row>
                    <Col md={{span: 18, offset: 3}}>
                        <h2>Requests I Posted</h2>
                        <Radio.Group value="Trips I posted">
                            <Radio.Button value="Upcoming" >
                              <Link to="/trips-posted-upcoming">
                                <h4>Upcoming</h4>
                              </Link>
                            </Radio.Button>
                            <Radio.Button value="Past">
                              <Link to="/trips-posted-past">
                                <h4>Past</h4>
                              </Link>
                            </Radio.Button>
                        </Radio.Group>
                    </Col>
                  </Row>                  
                </div> 
           <div style={{paddingTop: '24px'}}>
           <Row>
               <Col md={{span: 18, offset: 3}}>
                    <Card>
                        <Row>
                            <Col md={{span: 12}}>
                                <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                                    <Link to="/trip-detail"> Kampala to Mbarara</Link>
                                </h4>
                                <h4 style={{fontWeight: "normal"}} className="GrayText">Friday, March 8 at 7:15pm</h4>
                                <Divider/>
                                <Button type="primary">Edit</Button>&nbsp;
                                <Button  type="primary" style={{backgroundColor: '#ff3d00', borderWidth: '0px'}}>Cancel</Button>
                            </Col>
                            <Col md={{span: 11, offset: 1}}>
                                {/* <h4 style={{fontWeight: "normal", fontStyle: "italic"}} className="GrayText">No bookings on this trip</h4> */}
                                <h4 style={{fontWeight: "bold", color: '#0099ff'}}>
                                    <Link to="/trip-detail"> 2 Drivers Interested</Link><br/>
                                </h4>
                                <h4 style={{fontWeight: "normal", color: "green"}}>
                                    <Link to="/trip-detail"> You confirmed a Driver</Link>
                                </h4><br/>
                            </Col>
                        </Row>
                        
                    </Card>
               </Col>
           </Row>
                
           </div>
        </div>
    );
  }
}
export default RequestsPosted;
